import ContentfulImage from "models/data/contentful/ContentfulImage";
import ContentfulFile from 'models/data/contentful/ContentfulFile'

class ContentfulToApiStory {
	static map = contentfulImage => {
		return {
			id: ContentfulImage.id(contentfulImage),
			title: ContentfulImage.title(contentfulImage),
			description: ContentfulImage.description(contentfulImage),
			url: ContentfulFile.url(ContentfulImage.file(contentfulImage))
		};
	};
}

export default ContentfulToApiStory;
